export const ORDER_JWT_KEY: string = "PP_ORDER_JWT_KEY";

export const RECAPTCHA_SITE_KEY: string =
  process.env.REACT_APP_GLOBAL_RECAPTCHA_SITE_KEY || "";
export const ANONYMOUS_USER_EMAIL: string =
  process.env.REACT_APP_ANONYMOUS_USER_EMAIL_KEY || "ANONYMOUS_USER_EMAIL";

export enum Layouts {
  AUTH = "/auth",
  DASHBOARD = "/dashboard",
  USER_DASHBOARD = "/user-dashboard",
  PAYMENT_HISTORY = "/payment-history",
}

export const USE_BRAND_COLORS = process.env.REACT_APP_USE_BRAND_COLORS;
export const PP_BRAND_COLORS_PRIMARY =
  process.env.REACT_APP_BRAND_COLORS_PRIMARY;
export const PP_BRAND_COLORS_SECONDARY =
  process.env.REACT_APP_BRAND_COLORS_SECONDARY;

export const REACT_APP_PP_CONTACT_EMAIL = String(
  process.env.REACT_APP_CONTACT_EMAIL
);
export const PP_NOTICE = String(process.env.REACT_APP_PP_NOTICE ?? "");

export const PP_MAX_PAY_STEPS = 3;
